module.exports = __webpack_public_path__ + "img/magento-logo.7e88cb70.svg";